import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';

@Injectable()
export class HttpService {

  constructor(private http: HttpClient) {}

  post(data: any, url: string, headers = new HttpHeaders({ 'Content-Type': 'application/json' }), isSecured: boolean = false): Observable<any> {
    let options = this.OptionsForGetRequest(isSecured);

    if (headers && !isSecured) {
      options = { headers: headers, withCredentials: false };
    }
    if (headers && isSecured) {
      options = { headers: headers, withCredentials: true };
    }

    return this.http.post(url, data, options)
      .pipe(share());
  }

  put(data: any, url: string, headers = new HttpHeaders({ 'Content-Type': 'application/json' }), isSecured: boolean = false): Observable<any> {
    const options = { headers: headers, withCredentials: isSecured};

    return this.http.put(url, data, options)
      .pipe(share());
  }

  delete(url: string, data: any = null, isSecured: boolean = false): Observable<any> {
    const options = this.OptionsForGetRequest(isSecured, data);

    return this.http.delete(url, options)
      .pipe(share());
  }

  /**
   * @param httpOptions httpOptions should match to structure of options parameter on get methods of HttpClient class.
   */
  get(url: string, isSecured: boolean = false, httpOptions: any = null): Observable<any> {
    let options = this.OptionsForGetRequest(isSecured);
    if (httpOptions) {
      options = httpOptions;
    }

    return this.http.get(url, options)
      .pipe(share());
  }

  head(url: string, isSecured: boolean = false): Observable<any> {
    const options = this.OptionsForGetRequest(isSecured);
    return this.http.head(url, options)
      .pipe(share());
  }

  private OptionsForGetRequest(isSecured: boolean, body: any = null) {
    const headers = new HttpHeaders({
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT',
    });

    if (isSecured) {
      headers.append('Content-Type', 'application/json');
      if (body) {
        return { headers: headers, withCredentials: true, body: body };
      }
      return { headers: headers, withCredentials: true };
    } else {
      if (body) {
        return { headers: headers, body: body };
      }
      return { headers: headers };
    }
  }
}
